/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  removeRegionManager,
  retrieveRegionManagers,
  saveRegionManagerFailure,
  saveRegionManagerSuccess,
} from '@store/scenario/region-manager/region-manager-slice';

export const removeRegionManagerEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(removeRegionManager.type),
  concatMap((action: PayloadAction<number>) =>
    from(dependencies.regionManagerGateway.remove(action.payload)).pipe(
      concatMap(() => of(retrieveRegionManagers(), saveRegionManagerSuccess())),
      catchError((error: Error) => of(saveRegionManagerFailure(error.message || 'Failed to remove region manager'))),
    )),
);
